import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

import IconUsers from 'components/icons/IconUsers';

const styles = () => ({
  root: {
    height: 330,
  },
  iconUsers: {
    width: 110,
    height: 94,
  },
});

const UsersTableEmpty = ({ classes }) => (
  <Grid
    className={classes.root}
    container
    direction="column"
    justify="center"
    alignItems="center"
    spacing={24}
  >
    <Grid item>
      <IconUsers className={classes.iconUsers} />
    </Grid>
    <Grid item>
      <Typography variant="subheading" color="secondary">
        Unfortunately, there are no such users
      </Typography>
    </Grid>
  </Grid>
);

UsersTableEmpty.propTypes = {
  classes: PropTypes.shape({
    root: PropTypes.string.isRequired,
    iconUsers: PropTypes.string.isRequired,
  }).isRequired,
};

export default withStyles(styles)(UsersTableEmpty);



// WEBPACK FOOTER //
// ./src/components/settings/UsersTable/UsersTableEmpty.js